import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "dialog-mask"
};
const _hoisted_2 = {
  class: "detail-dialog"
};
const _hoisted_3 = {
  key: 0,
  class: "empty"
};
const _hoisted_4 = {
  key: 1,
  class: "empty"
};
const _hoisted_5 = {
  key: 2,
  class: "cards"
};
const _hoisted_6 = {
  class: "student-main"
};
const _hoisted_7 = {
  class: "card-title"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "info"
};
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  key: 0,
  class: "remark-panel"
};
const _hoisted_13 = {
  class: "remark-actions"
};
const _hoisted_14 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("header", null, [_cache[5] || (_cache[5] = _createElementVNode("h2", null, "班级详情", -1)), _createVNode(_component_el_select, {
    modelValue: $data.classId,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.classId = $event),
    filterable: "",
    class: "class-select",
    onChange: $options.loadStudents
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.classes, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.id,
        label: item.name,
        value: item.id
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.keyword = $event),
    class: "search",
    placeholder: "搜索学员名称/联系电话..."
  }, null, 512), [[_vModelText, $data.keyword, void 0, {
    trim: true
  }]]), _createElementVNode("button", {
    class: "back",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('close'))
  }, "← 返回")]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_3, "正在加载...")) : $options.filteredStudents.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无学生")) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredStudents, student => {
    return _openBlock(), _createElementBlock("article", {
      key: student.id,
      class: _normalizeClass(['student-card', {
        editing: $data.editingId === student.id
      }])
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("h3", null, _toDisplayString(student.name), 1), _createElementVNode("span", null, _toDisplayString(student.isEnrolled ? "在读学员" : "绑定学员"), 1)]), _createElementVNode("button", {
      class: "edit",
      onClick: $event => $options.toggleEdit(student)
    }, "✎", 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_cache[6] || (_cache[6] = _createElementVNode("b", null, "联系电话", -1)), _createElementVNode("span", null, _toDisplayString($options.phoneText(student)), 1)]), _createElementVNode("div", _hoisted_10, [_cache[7] || (_cache[7] = _createElementVNode("b", null, "年级", -1)), _createElementVNode("span", null, _toDisplayString(student.grade || "未填写年级"), 1)]), _createElementVNode("div", _hoisted_11, [_cache[8] || (_cache[8] = _createElementVNode("b", null, "学校", -1)), _createElementVNode("span", null, _toDisplayString(student.school || "未填写学校"), 1)])]), $data.editingId === student.id ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[9] || (_cache[9] = _createElementVNode("label", null, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.remarkDraft = $event),
      placeholder: "请输入该学生在当前班级的备注"
    }, null, 512), [[_vModelText, $data.remarkDraft]]), _createElementVNode("div", _hoisted_13, [_createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = (...args) => $options.cancelEdit && $options.cancelEdit(...args))
    }, "取消"), _createElementVNode("button", {
      class: "save",
      onClick: $event => $options.saveRemark(student)
    }, "保存", 8, _hoisted_14)])])) : _createCommentVNode("", true)], 2);
  }), 128))]))])]);
}